module.exports = __webpack_public_path__ + "static/media/supabase.1b788bc2.svg";